import http from './plugin/ajax'
//= ==========合同变更==========
export const getContractChangeList = (data) => http.post('/contractChange/list', data) // 查询变更合同列表
export const getContractChangeDetail = (data) => http.get(`/contractChange/detail/${data.contractCode}/${data.changeId}`) // 获取合同变更详情
export const approvalContractChange = (data) => http.post('/contractChange/audit', data)// 合同变更审批
export const getContractChangeJournal = (data) => http.get(`/contractChange/ChangeLogType/${data}`) // 获取变更日志
export const getContractChangeJournalDetail = (data) => http.get(`/contractChange/listChangeLog/${data}`) // 变更日志详情
export const setContracChange = (data) => http.post('/contractChange/update', data)// 合同变更
